"use client"
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from "react-device-detect";
import { resetUserDetails, setUserDetails, updateUserDetail } from '@/reducers/user/userSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import styles from './login.module.css'
import { useRouter } from 'next/router'
//forgerock
import { Config, FRAuth, FRUser, TokenManager, TokenStorage, UserManager } from '@forgerock/javascript-sdk';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { APP_URL, DIGITAL_SALES_PATH, FASTTRACK_PATH, FASTTRACK_RECORD_ID_INVALIDATE_INTERVAL_IN_HOURS, FORGOT_PASSWORD_PATH, JOURNEY_FORGOT_PASSWORD, JOURNEY_LOGIN_NORMAL, JOURNEY_LOGIN_UAEPASS, JOURNEY_REGISTER, JOURNEY_USER_SEARCH, LEAD_TO_LEASE_HOME_PAGE, LIVING_IN_HOME_PAGE, LOGIN_PATH, NO_PROPERTIES_PATH, OTP_PATH, OVERVIEW_PATH, PROFILE_PAGE_PATH, REGISTRATION_PATH, SPA_JOURNEY_PATH, UAE_PASS_STAGE_URL, UAEPASS_CLIENT_ID, UAEPASS_CLIENT_SECRET, UAEPASS_REDIRECT_URI } from '@/config/constants';
import { setForgerockConfig, validateToken, validateUserinSPAUAEPassFlow, extractTokenTiming } from '@/services/forgeRockService.service';
import LoggedOutLayout from '@/layouts/loggedOut/loggedOutLayout';
import Link from 'next/link';
import { Autocomplete, Checkbox, CircularProgress, IconButton, InputAdornment, InputLabel, TextField } from '@mui/material';
import en from '@/locales/en/loginContent';
import ar from '@/locales/ar/loginContent';
import { useForm } from 'react-hook-form';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { getFeatureFlags, getGlobalConfig, getUAEPassInfo, getUserDetails } from '@/services/apiService.service';
import { resetGlobalConfig, setGlobalConfig } from '@/reducers/globalConfig/globalConfigSlice';
import { decryptDataWithDecryptedKey, decryptSymmetricKey, encryptDataWithDecryptedKey, encryptToken, fetchEncryptedSymmetricKey, getCurrentEncryptedSymmetricKey } from '@/services/utils/encryption';
import { updateLoginRegularJourneyStep } from '@/reducers/loginRegularJourney/loginRegularJourneySlice';
import { updateForgotPasswordJourneyStep } from '@/reducers/forgotPasswordJourney/forgotPasswordJourneySlice';
import { updateRegistrationJourneyStep } from '@/reducers/registrationJourney/registrationJourneySlice';
import { addPortalUsers, removePortalUsers } from '@/reducers/portalUsers/portalUsersSlice';
import CommonPopup from '@/components/commonPopup/commonPopup';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { event as gaEvent } from '@/lib/ga';
import { setFeatureFlag } from '@/reducers/featureFlag/featureFlagSlice';
import { resetForgerockUserInfo, updateForgerockUserInfo } from '@/reducers/forgerockUserInfo/forgerockUserInfoSlice';
import { checkIsEmailSameInUAEPass, checkIsUAEPassSPAUserLoginWithEmail, clearSPAUAEAuthSessionVariables, SPA_SESSION_KEYS } from '@/components/SPAJounrney/utils/spaUtils';
import { addError } from "@/reducers/errorHandler/errorHandlerSlice";
import arSPAJourneyContent from "@/locales/ar/spaJourneyContent";
import enSPAJourneyContent from "@/locales/en/spaJourneyContent";
import UAEPassAuthLoader from '@/components/SPAJounrney/UAEPassAuthLoader';

type userLogin = {
    mail: string
    password: string
    rememberMe: boolean
    terms: boolean
}
const Login = () => {
    const portalUsers = useSelector((state: any) => {
        return [...state.portalUsers]
    })
    const router = useRouter();
    const dispatch = useDispatch()
    const [loginSuccessStatus, setLoginSuccessStatus] = useState<any>('')
    const [uaeAuthResponse, setUaeAuthResponse]: any = useState(null);
    const [uAEPassInitiated, setUAEPassInitiated] = useState(false);
    const [nextStepLoading, setNextStepLoading] = useState(false)
    const [isUAEPassLogin, setIsUAEPassLogin] = useState(false);
    const [isUAEPassLoading, setIsUAEPassLoading] = useState(false);
    const [isUAEPassFromSPALoading, setIsUAEPassFromSPALoading] = useState(false);
    const user = useSelector((state: any) => {
        return { ...state.user }
    })
    const { locale } = router;
    const t: any = locale == 'en' ? en : ar;
    const spaContent: any = locale == "en" ? enSPAJourneyContent?.verification : arSPAJourneyContent?.verification;

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, touchedFields },
    } = useForm<userLogin>(
        {
            mode: 'onBlur',
            reValidateMode: 'onBlur',
        }
    )
    const [showPassword, setShowPassword] = React.useState(false);
    const formData: any = watch()
    const handleClickShowPassword = () => setShowPassword((show) => !show);


    // const getProfileDetailsandRedirect = async (email: string, userDate: any) => {
    //     dispatch(resetGlobalConfig())
    //     dispatch(updateUserDetail({
    //         account: {
    //             PersonEmail: email
    //         },
    //         forgeRockData: {
    //             Gender__pc: userDate.custom_gender ? userDate.custom_gender : userDate.gender,
    //             Nationality__pc: userDate.custom_nationalityEN,
    //             Name: userDate.name,
    //             FirstNameAR: userDate.custom_givenNameAR,
    //             LastNameAR: userDate.custom_familyNameAR,
    //             FirstName: userDate.given_name,
    //             LastName: userDate.family_name,
    //             NationalIdNumber__pc: userDate.custom_EID,
    //             NameInArabic__c: (userDate.custom_givenNameAR ?? "") + " " + (userDate.custom_familyNameAR ?? "")
    //         },
    //         isAuthenticated: true
    //     }))
    //     debugger;
    //     // if (user.recordId) {
    //     //     router.push(`${APP_URL}${FASTTRACK_PATH}?recordId=${user.recordId}`)
    //     // }
    //     // else {
    //     //     router.push(`${APP_URL}${OVERVIEW_PATH}`)
    //     // }
    //     setIsUAEPassLoading(false)
    //
    //
    // }
    const getFeatureFlag = async () => {
        try {
            const featureFlagResponse = await getFeatureFlags();
            if (featureFlagResponse?.web){
                dispatch(setFeatureFlag(featureFlagResponse.web));
                return featureFlagResponse.web;
            }
        } catch (error) {

        }
    }

   const onRecieveTokenAfterUAEPass = (tokens: any) => {
    datadogLogs.logger.info(`Forgerock: UAE pass token request - started - ${JSON.stringify({ accessToken: tokens.accessToken })}`);
        let personalEmail='';
        dispatch(
        updateUserDetail({
            token: encryptToken(tokens.accessToken),
            ...extractTokenTiming(tokens),
        }),
        );
        UserManager.getCurrentUser()
        .then((data1: any) => {
            setLoginSuccessStatus("Authentication Successful");
            dispatch(resetGlobalConfig());
            personalEmail=data1.email;
            try { gaEvent({ action: "uaepass_login_success", params: { category: 'auth', label: 'UAE Pass Login Success', email: personalEmail } }); } catch {}
            dispatch(updateForgerockUserInfo({
                ...data1
            }))
            dispatch(
            updateUserDetail({
                account: {
                PersonEmail: data1.email,
                },
                forgeRockData: {
                Gender__pc: data1.custom_gender
                    ? data1.custom_gender
                    : data1.gender,
                Nationality__pc: data1.custom_nationalityEN,
                Name: data1.name,
                FirstNameAR: data1.custom_givenNameAR,
                LastNameAR: data1.custom_familyNameAR,
                FirstName: data1.given_name,
                LastName: data1.family_name,
                NationalIdNumber__pc: data1.custom_EID,
                NameInArabic__c:
                    (data1.custom_givenNameAR ?? "") +
                    " " +
                    (data1.custom_familyNameAR ?? ""),
                },
                isAuthenticated: true,
            }),
            );
            getFeatureFlag()
            return getUserDetails(data1.email, tokens.accessToken);
        })
        .then(async(dataUserDetails) => {
            const isUserExists=await checkUserExists(personalEmail);   
            if(!isUserExists){
                router.push(`${REGISTRATION_PATH}?uaePassRegister=${personalEmail}`)
                return;
            }   

            const { 
                enableFastTrack, 
                salesOrders, 
                fasttrackRecord,
                enableNOCFastTrack,
                NocFastTrack, 
                digitalSales,
                account,
                ContractIds, 
                LeasingOpportunityIds
            } = dataUserDetails.data?.data;
            const recordId = fasttrackRecord?.Id;
            const hasSalesOrders = !!salesOrders?.length;
            const hasContractIds = !!ContractIds?.length;
            const hasLeasingOpportunityIds = !!LeasingOpportunityIds?.length;
            const nocRecordId=NocFastTrack?.Id;
            const flags = await getFeatureFlag();
            dispatch(
                updateUserDetail({
                  isTenant: false,
                  isProspectUser: hasLeasingOpportunityIds
                })
            );
            datadogLogs.logger.info(`Forgerock: UAE pass login request success - ${personalEmail} ${JSON.stringify(dataUserDetails)}`);
            // Derive user_type strictly exclusive
            try {
              datadogLogs.logger.info(`Login: UAE Pass user type for ${personalEmail}}`);
            } catch {}
            if (!hasSalesOrders && enableFastTrack && recordId && !isMobile) {
            router.push(`${FASTTRACK_PATH}?recordId=${recordId}`);
            return;
            }
            if(enableNOCFastTrack && nocRecordId && !isMobile){
                router.push(`${FASTTRACK_PATH}?recordId=${nocRecordId}`);
                return;
            }
            if (hasSalesOrders) {
            router.push(`${OVERVIEW_PATH}`);
            return;
            }
            const currentDigitalSaleRecordId = digitalSales?.[0]?.Id;
            if (currentDigitalSaleRecordId) {
                if(account?.Id) {
                    dispatch(updateUserDetail({
                        account: {
                            ...user.account,
                            Id: account.Id
                        },
                    }))
                }
                router.push(`${DIGITAL_SALES_PATH}?recordId=${currentDigitalSaleRecordId}`);
                return;
            }          
            if(flags?.liveinTenant && hasContractIds && !hasSalesOrders){
              dispatch(
                updateUserDetail({
                  account: account,
                  isTenant: hasContractIds && !hasSalesOrders,
                  ContractIds:ContractIds,
                })
              );
              router.push(`${LIVING_IN_HOME_PAGE}`);
              return;
            }
            if(flags.lumenLeasingJourney && !hasSalesOrders && !hasContractIds && hasLeasingOpportunityIds){
              dispatch(
                updateUserDetail({
                  account: account,
                  ContractIds:ContractIds,
                  LeasingOpportunityIds:LeasingOpportunityIds,
                })
              );
              router.push(`${LEAD_TO_LEASE_HOME_PAGE}`);
              return;
            }
            router.push(`${NO_PROPERTIES_PATH}`);
        })
        .catch((e: any) => {
            setLoginSuccessStatus("API_FAILURE_ERROR");
            datadogLogs.logger.info(`Forgerock: UAE pass request failure - ${personalEmail} ${e}`);
            try { gaEvent({ action: "uaepass_login_failure", params: { category: 'auth', label: 'UAE Pass Login Failure', email: personalEmail } }); } catch {}
        });
    
   };

    const LogoutUAEPass = async () => {
        await FRUser.logout()
        dispatch(updateUserDetail({
            token: '',
            isAuthenticated: false,
            userMessage: "uaePassSessionInvalidated"
        }))
        window.open(UAE_PASS_STAGE_URL + APP_URL + LOGIN_PATH, "_self")
        dispatch(resetUserDetails())
    }


    //login and logout for regular login start
    const loginCheckIfExistingSession = async (currentJourney: any, journeyKey: any, userData?: any) => {
        setForgerockConfig(journeyKey)
        let user: any
        try {
            user = await UserManager.getCurrentUser();
        } catch (e) {
            throw (e)
        }
        if (user) {
            const userDataForgerock: any = await UserManager.getCurrentUser()
            if (journeyKey === currentJourney) {
                await FRUser.logout()
                dispatch(updateUserDetail({
                    isAuthenticated: false,
                    token: ''
                }))
                if (currentJourney === JOURNEY_LOGIN_UAEPASS) {
                    dispatch(updateUserDetail({
                        userMessage: "uaePassSessionInvalidated"
                    }))
                    window.open(UAE_PASS_STAGE_URL + APP_URL + LOGIN_PATH, "_self")
                    return
                }
                setForgerockConfig(currentJourney)
                await loginRegularProgression(userData)
                return
            }
            else {
                await FRUser.logout()
                dispatch(updateUserDetail({
                    isAuthenticated: false,
                    token: ''
                }))
                if (journeyKey === JOURNEY_LOGIN_UAEPASS) {
                    dispatch(updateUserDetail({
                        userMessage: "uaePassSessionInvalidated"
                    }))
                    window.open(UAE_PASS_STAGE_URL + APP_URL + LOGIN_PATH, "_self")
                    return
                }
                throw ('Different journey')
            }
        }
    }
    const loginRegularProgression = async (data: any) => {
        try {
            dispatch(updateForgotPasswordJourneyStep(''));
            dispatch(updateRegistrationJourneyStep(''));
            dispatch(updateLoginRegularJourneyStep(''));
            //regular login step 0
            const mail = data.mail.trim();
            const password = data.password;
            const regularLoginStepZeroResponse: any = await FRAuth.start();
            datadogLogs.logger.info(`Forgerock: Login request started - ${JSON.stringify({ email: mail })}`);
            //logging step 0 response

            let regularLoginStepOneRequest: any = { ...regularLoginStepZeroResponse }
            regularLoginStepOneRequest.payload.callbacks[0].input[0].value = mail;
            regularLoginStepOneRequest.payload.callbacks[1].input[0].value = password;
            const regularLoginStepOneResponse: any = await FRAuth.next(regularLoginStepOneRequest);
            //logging step 1 response

            if (regularLoginStepOneResponse.type === 'LoginFailure' || regularLoginStepOneResponse.payload?.callbacks?.[0]?.output?.[0]?.value !== "OTP") {
                setNextStepLoading(false)
                datadogLogs.logger.info(`Forgerock: Login request failure - ${JSON.stringify({ email: mail })} ${JSON.stringify(regularLoginStepOneResponse)}`);
                try { gaEvent({ action: "login_failure", params: { category: 'form', label: 'Login Failure', email: mail } }); } catch {}
                if(regularLoginStepOneResponse.payload?.callbacks?.[0]?.output?.[0]?.value?.toLowerCase().includes("your account has been disabled")){
                    setLoginSuccessStatus('user_disabled')
                }
                else if(regularLoginStepOneResponse.payload?.message?.toLowerCase().includes("user locked out") || regularLoginStepOneResponse.payload?.callbacks?.[0]?.output?.[0]?.value?.toLowerCase().includes("user locked out")){
                    setLoginSuccessStatus('user_locked_out')
                    setTimeout(()=>{router.push(`${FORGOT_PASSWORD_PATH}`)},1000)
                }
                else if(regularLoginStepOneResponse.payload?.message?.toLowerCase().includes("warning: you will be locked out after 2 more failure") || regularLoginStepOneResponse.payload?.callbacks?.[0]?.output?.[0]?.value?.toLowerCase().includes("warning: you will be locked out after 2 more failure")){
                    setLoginSuccessStatus('third_attempt')
                }
                else if(regularLoginStepOneResponse.payload?.message?.toLowerCase().includes("warning: you will be locked out after 1 more failure") || regularLoginStepOneResponse.payload?.callbacks?.[0]?.output?.[0]?.value?.toLowerCase().includes("warning: you will be locked out after 1 more failure")){
                    setLoginSuccessStatus('fourth_attempt')
                }
                else{
                    setLoginSuccessStatus('auth_unsuccessful')
                }
                return
            }
            dispatch(updateLoginRegularJourneyStep(JSON.stringify(regularLoginStepOneResponse)));
            dispatch(updateUserDetail({
                account: {
                    PersonEmail: mail
                }
            }))
            datadogLogs.logger.info(`Forgerock: Login request success - ${mail} ${JSON.stringify(regularLoginStepOneResponse)}`);
            try { gaEvent({ action: "login_requires_otp", params: { category: 'navigation', label: 'Login Requires OTP', email: mail } }); } catch {}
            router.push(`${OTP_PATH}`)
        } catch (e: any) {
            datadogLogs.logger.info(`Forgerock: Login request failure - ${JSON.stringify({ email: data.mail })}${e}`);
            try { gaEvent({ action: "login_failure", params: { category: 'form', label: 'Login Exception', email: data?.mail } }); } catch {}
            setNextStepLoading(false)
            if (e?.message?.includes("The request requires some interaction that is not allowed.")) {
                setLoginSuccessStatus('COOKIE_MESSAGE')
            }
            else {
                setLoginSuccessStatus('API_FAILURE_ERROR')
            }


        }
    }


    const checkUserExists=async (email:string)=>{
        setForgerockConfig(JOURNEY_USER_SEARCH)
        const userSearchStartResponse: any = await FRAuth.start();
        userSearchStartResponse.payload.callbacks[0].input[0].value = email;
        const userSearchResponse: any = await FRAuth.next(userSearchStartResponse);
        const hasUserExists=userSearchResponse.payload.callbacks[0].output[0].value === 'false'?false:true;
        setForgerockConfig(JOURNEY_LOGIN_UAEPASS)
        return hasUserExists;
    }

    const loginUAEPassProgression = async () => {

        setForgerockConfig(JOURNEY_LOGIN_UAEPASS)
        try {
            //UAE pass login step 0
            const uaePassLoginStepZero: any = await FRAuth.start();
            //UAE pass login step 1
            const uaePassLoginStepOne: any = await FRAuth.next(uaePassLoginStepZero);
            FRAuth.redirect(uaePassLoginStepOne);
        } catch (e) {
        }
    }
    //login and logout for regular login end
    const loginUAEPass = async (e?: any) => {
        datadogLogs.logger.info(`Forgerock: UAE pass login started`);
        try { gaEvent({ action: "uaepass_login_start", params: { category: 'button', label: 'UAE Pass Login Start' } }); } catch {}
        e?.preventDefault()
        dispatch(updateUserDetail({
            userMessage: null
        }))
        dispatch(updateUserDetail({
            recordId: user.recordId ? user.recordId : router.query.recordId,
            recordIdLastUsedTime: router.query.recordId ? (new Date()).getTime() : user.recordIdLastUsedTime,
        }))
        setIsUAEPassLogin(true)
        setIsUAEPassLoading(true)
        setLoginSuccessStatus('')
        try {
            await loginCheckIfExistingSession(JOURNEY_LOGIN_UAEPASS, JOURNEY_LOGIN_UAEPASS)
        } catch (e) {
            try {
                await loginCheckIfExistingSession(JOURNEY_LOGIN_UAEPASS, JOURNEY_LOGIN_NORMAL)
                return
            } catch (e) {
                setForgerockConfig(JOURNEY_LOGIN_UAEPASS)
                await loginUAEPassProgression()
            }
        }
    }
    //Login UAE Pass step 0 and 1

    //Login Regular Forgerock
    const loginRegular = async (data: any) => {
        dispatch(updateUserDetail({
            userMessage: null
        }))
        try { gaEvent({ action: "login_submit", params: { category: 'form', label: 'Login Submit', email: data?.mail } }); } catch {}
        if(formData.rememberMe){
            dispatch(addPortalUsers(data.mail))
        }else{
            dispatch(removePortalUsers(data.mail))
        }
        dispatch(updateUserDetail({
            recordId: user.recordId ? user.recordId : router.query.recordId,
            recordIdLastUsedTime: router.query.recordId ? (new Date()).getTime() : user.recordIdLastUsedTime,
        }))
        setNextStepLoading(true)
        setIsUAEPassLogin(false)
        setLoginSuccessStatus('')
        try {
            await loginCheckIfExistingSession(JOURNEY_LOGIN_NORMAL, JOURNEY_LOGIN_NORMAL, data)
        } catch (e) {
            try {
                await loginCheckIfExistingSession(JOURNEY_LOGIN_NORMAL, JOURNEY_LOGIN_UAEPASS, data)
                return
            } catch (e) {
                setForgerockConfig(JOURNEY_LOGIN_NORMAL)
                try {
                    await FRUser.logout()
                    dispatch(updateUserDetail({
                        isAuthenticated: false,
                        token: ''
                    }))
                } catch (e) {

                }
                await loginRegularProgression(data)
            }
        }
    }
    // step progression for uae pass
    const stepProgression = async (data: any) => {
        setUaeAuthResponse(null);
        if (data.type === 'LoginSuccess' && data.payload.tokenId != "") {
            TokenManager.getTokens({
                forceRenew: true,
                login: 'redirect'
            })
            .then(onRecieveTokenAfterUAEPass)
            // .then((tokens: any) => {
            //     dispatch(updateUserDetail({
            //         token: encryptToken(tokens.accessToken)
            //     }))
            //     UserManager.getCurrentUser().then((data1: any) => {
            //         setLoginSuccessStatus('Authentication Successful')
            //         getProfileDetailsandRedirect(
            //             data1.email,
            //             data1
            //         )
            //     }).catch((err: any) => {
            //         setLoginSuccessStatus('API_FAILURE_ERROR')
            //     })
            // })
            .catch((err: any) => {
                setLoginSuccessStatus('API_FAILURE_ERROR')
                datadogLogs.logger.info(`Forgerock: UAE pass request failure - ${err}`);

                //uae pass crack
                // getProfileDetailsandRedirect("")
            });

        } else {
            try {
                await FRUser.logout()
                dispatch(updateUserDetail({
                    isAuthenticated: false,
                    token: '',
                }))
                window.open(UAE_PASS_STAGE_URL + APP_URL + LOGIN_PATH, "_self")
            } catch (e: any) {
            }
        }
    }
    useEffect(() => {
        if (uaeAuthResponse != null) {
            if (uaeAuthResponse.type.toString().trim() == "LoginSuccess" || uaeAuthResponse.type.toString().trim() == "LoginFailure") {
                datadogLogs.logger.info(`Forgerock: UAEpass auth response  - success - ${JSON.stringify({ uaeAuthResponse })} `)
                stepProgression(uaeAuthResponse)
            }
            else {
                datadogLogs.logger.info(`Forgerock: UAEpass auth response - failure - ${JSON.stringify({ uaeAuthResponse })} `)
                dispatch(updateUserDetail({
                    userMessage: uaeAuthResponse.payload.callbacks[0]?.output[0].value.trim() === 'You are not a valid customer' ? 'UAEPassInvalidCustomerText' : uaeAuthResponse.payload.callbacks[0]?.output[0].value === "You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact 800ALDAR to access the services." ? 'notSOP3Text' : uaeAuthResponse.payload.callbacks[0]?.output[0].value
                }))
                FRAuth.next(uaeAuthResponse).then((data: any) => {
                    setUaeAuthResponse(data);
                })
            }
        }
    }, [uaeAuthResponse])

    //this is to unset UAEPass login fail message after being displayed once
    useEffect(()=>{

        if(user.wasShownOnce) {
            dispatch(updateUserDetail({
                wasShownOnce: false,
                userMessage: null
            }))
            return;
        }
        if(["UAEPassInvalidCustomerText", "notSOP3Text"].indexOf(user.userMessage) !== -1) {
            dispatch(updateUserDetail({
                wasShownOnce:true,
                userMessage: user.userMessage
            }))
        }
    },[])

    const onUAEPASSVerificationForDSPA = async (code: any,spaRecordId: string) => {
        const emailFromSession = sessionStorage?.getItem(SPA_SESSION_KEYS.UAEPassSPAUserEmail);
        try {
            await fetchEncryptedSymmetricKey();
            const infoPayload = {
                code,
                referenceId: user?.account?.PersonEmail,
                customerId: user?.account?.Id
            };
            const uaePassInfoResponse: any = await getUAEPassInfo({
                dataBlob: encryptDataWithDecryptedKey(infoPayload),
                keyBlob: getCurrentEncryptedSymmetricKey()
            }, user?.token);

            decryptSymmetricKey(uaePassInfoResponse.data.keyBlob);
            const decryptedUAEPassInfo: any = decryptDataWithDecryptedKey(uaePassInfoResponse.data.dataBlob);
            if (decryptedUAEPassInfo === 403) {
                clearSPAUAEAuthSessionVariables();
                dispatch(
                  addError({
                    type: 403,
                    errorMessage: "sessionExpiredMessage",
                    buttonText: "",
                  })
                );
                return;
            }
            if(!checkIsEmailSameInUAEPass(decryptedUAEPassInfo.email, true)) {
                datadogLogs.logger.info(`Forgerock-SPA: UAE pass login request failed email mismatch  -${JSON.stringify({aldarEmail:emailFromSession,uaePassEmail:decryptedUAEPassInfo?.email})}`);
                sessionStorage.setItem(SPA_SESSION_KEYS.spaUAEPassError, spaContent.UAEPassLoginEmailMismatch);
            } else {
                datadogLogs.logger.info(`Forgerock-SPA: UAE pass login request success - ${JSON.stringify({aldarEmail:emailFromSession,uaePassEmail:decryptedUAEPassInfo?.email})}`)
                // To be cleared in docusign v2/signature API call or component exit.
                sessionStorage.setItem(SPA_SESSION_KEYS.spaUAEPassAuthSuccess,"true");  
            }
            router.push(`${SPA_JOURNEY_PATH}?recordId=${spaRecordId}`);
        } catch(error) {
            datadogLogs.logger.info(`Forgerock-SPA: UAE pass login request failed onUAEPASSVerificationForDSPA - ${emailFromSession} ${JSON.stringify(error)}`);
            sessionStorage.setItem(SPA_SESSION_KEYS.spaUAEPassError, spaContent.UAEPassLoginFailed);
            router.push(`${SPA_JOURNEY_PATH}?recordId=${spaRecordId}`);
        }
    }

    const verifyUserOnUAEPassForDSPA = async (code: any, spaRecordId: string) => {
        const emailFromSession = sessionStorage.getItem(SPA_SESSION_KEYS.UAEPassSPAUserEmail);
        try {
            const initResponse = await validateUserinSPAUAEPassFlow({});
            const paylaod = {
                code,
                clientId: UAEPASS_CLIENT_ID,
                clientSecret: UAEPASS_CLIENT_SECRET,
                redirectUri: UAEPASS_REDIRECT_URI
            }
            initResponse.callbacks[0].input[0].value = JSON.stringify(paylaod);
            const finalResponse = await validateUserinSPAUAEPassFlow(initResponse);
            const userMessage = finalResponse.callbacks[0].output[0].value;
            const userEmail = userMessage.split(": ")[1];
            if(!checkIsEmailSameInUAEPass(userEmail, true)) {
                datadogLogs.logger.info(`Forgerock-SPA: UAE pass login request failed email mismatch  -${JSON.stringify({aldarEmail: emailFromSession, uaePassEmail: userEmail})}`);
                sessionStorage.setItem(SPA_SESSION_KEYS.spaUAEPassError, spaContent.UAEPassLoginEmailMismatch);
            } else {
                datadogLogs.logger.info(`Forgerock-SPA: UAE pass login request success - ${JSON.stringify({aldarEmail: emailFromSession, uaePassEmail: userEmail})}`)
                // To be cleared in docusign v2/signature API call or component exit.
                sessionStorage.setItem(SPA_SESSION_KEYS.spaUAEPassAuthSuccess, "true");  
            }
            router.push(`${SPA_JOURNEY_PATH}?recordId=${spaRecordId}`);
        } catch(error) {
            datadogLogs.logger.info(`Forgerock-SPA: UAE pass login request failed verifyUserOnUAEPassForDSPA - ${emailFromSession} ${JSON.stringify(error)}`);
            sessionStorage.setItem(SPA_SESSION_KEYS.spaUAEPassError, spaContent.UAEPassLoginFailed);
            router.push(`${SPA_JOURNEY_PATH}?recordId=${spaRecordId}`);
        }
    }

    useEffect(() => {
        if (router.isReady) {
            // if (!router.query.recordId && user.recordId != "undefined" && user.recordId) {
            //     router.push(`/?recordId=${encodeURIComponent((router.query.recordId ? router.query.recordId : user.recordId) as string)}`);
            // }
            if(!router.query.recordId){
                let getTimeLapseFromLastRecordIdUsage: any
                if(user.recordIdLastUsedTime){
                    getTimeLapseFromLastRecordIdUsage = ((new Date()).getTime() - user.recordIdLastUsedTime) / (1000 * 3600)
                }
                if (user.recordId && (!user.recordIdLastUsedTime || getTimeLapseFromLastRecordIdUsage > parseInt(FASTTRACK_RECORD_ID_INVALIDATE_INTERVAL_IN_HOURS))) {
                    dispatch(updateUserDetail({
                        recordId: null,
                        recordIdLastUsedTime: null
                    }))
                }
            }
            if (router.query.recordId) {
                dispatch(updateUserDetail({
                    recordId: router.query.recordId,
                    recordIdLastUsedTime: router.query.recordId ? (new Date()).getTime() : user.recordIdLastUsedTime,
                    userMessage: null
                }))
            }
            setForgerockConfig(JOURNEY_LOGIN_UAEPASS)


            const spaRecordId = sessionStorage.getItem(SPA_SESSION_KEYS.spaRecordId);
            if (router.query.error) {
                if(checkIsUAEPassSPAUserLoginWithEmail() && spaRecordId?.length) {
                    const emailFromSession = sessionStorage.getItem(SPA_SESSION_KEYS.UAEPassSPAUserEmail)
                    datadogLogs.logger.info(`Forgerock-SPA: UAE pass login request Failed - ${emailFromSession} ${JSON.stringify(router.query.error)}`);
                    sessionStorage.setItem(SPA_SESSION_KEYS.spaUAEPassError, router.query.error?.includes("cancelled") ? spaContent.UAEPassLoginCancelled : spaContent.UAEPassLoginFailed);
                    setTimeout(() => {
                        router.push(`${SPA_JOURNEY_PATH}?recordId=${spaRecordId}`);
                    }, 1000);
                    return;
                }
                setIsUAEPassLogin(true)
                setIsUAEPassLoading(false)
                setLoginSuccessStatus('UAEPassLoginCancelled')
                return
            }
            if (router.query.code && router.query.state && uAEPassInitiated == false) {
                setIsUAEPassLoading(true)
                setIsUAEPassLogin(true)
                setUAEPassInitiated(true)
                
                if (checkIsUAEPassSPAUserLoginWithEmail() && spaRecordId?.length) {
                    verifyUserOnUAEPassForDSPA(router.query.code, spaRecordId)
                } else {
                    FRAuth.resume(APP_URL + router.asPath).then((data: any) => {
                        setUaeAuthResponse(data);
                    }).catch((error: any) => {
                        localStorage.clear()
                        setUAEPassInitiated(false)
                        loginUAEPass()
                    })
                }
            }
            else {
                setIsUAEPassLoading(false)
                if (user) {
                    if (user.userMessage && ["useFasttrackLink", "noPropertiesMessage"].indexOf(user.userMessage) === -1) {
                        setIsUAEPassLogin(true)
                        setLoginSuccessStatus(user.userMessage)

                        dispatch(updateUserDetail({
                            userMessage: null
                        }))
                    }

                }
            }
        }

    }, [router.query.code, router.query.state, router.query.error, router.query.recordId])

    useEffect(() => {
        if (router.isReady) {
            if (["useFasttrackLink", "noPropertiesMessage"].indexOf(user.userMessage) !== -1) {
                document.getElementById('loggedOutfooter')?.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
            }
            if (!router.query.code) {
                try {
                    FRUser.logout().then((data: any) => {
                        dispatch(updateUserDetail({
                            isAuthenticated: false,
                            token: ''
                        }))
                    })

                } catch (e) {
                }
            }            
        }

        // Using URLSearchParams to avoid the delay in hiding login page using router.isReady
        const queryParams = new URLSearchParams(window.location.search);
        if(checkIsUAEPassSPAUserLoginWithEmail() && (queryParams.get("code") || queryParams.get("error"))) { 
            setIsUAEPassFromSPALoading(true) 
        }
    }, [])
    const checkSubmitIsEnabled = (): boolean => {
        // for debugging
        return true
        return Object.keys(touchedFields).length < 2 && formData.terms ? false : Object.keys(errors).length === 0 && formData.terms;
    }

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    useEffect(()=>{
        if (user?.account?.PersonEmail && isUAEPassLogin && user?.token) {
          datadogRum.setUser({
            id:user.account.PersonEmail,
            email:user.account.PersonEmail,
          });
        }
      },[user.token])
    
    if(isUAEPassFromSPALoading) {
        return <UAEPassAuthLoader />
    }

    return (
        <>
            <div className={styles.Login}>
                <div className={styles.leftPortion}>
                    <div className={styles.left_inner_portion}>
                        <section className={styles.loginHeader}>
                            <div className={styles.logo}>
                                <img alt="logo" width="auto" height={48} src="/live/en/iceridgeresources/images/logos/logo-vertical-white.svg" onClick={LogoutUAEPass}></img>
                            </div>

                            <div className="heading">
                                {t['login_heading']}
                            </div>
                            <div className="sub_heading">
                                {t['login_subheading']}
                            </div>
                            
                            {/* <img className="uaePassButton" src="/uaePassButtonActive.svg" onClick={loginUAEPass}></img> */}
                        </section>

                        <section className={styles.loginForm}>
                            {/* <div className={styles.forgerockTopBanner}>One Aldar</div> */}
                            <form onSubmit={handleSubmit(loginRegular)} className={styles.loginUserForm}>
                                <div className={styles.formControl}
                                    key={`FormControl_mail`}>
                                    <InputLabel
                                        className={`${styles.formElementLabel} ${styles.mail} ${styles.requiredLabel}`}
                                        key={`InputLabel_mail`}>{t.fields.mail.label}</InputLabel>

                                    <Autocomplete
                                        id="loginEmail"
                                        freeSolo
                                        disableClearable={true}
                                        options={portalUsers.map((option: any) => option)}
                                        renderInput={(params: any) => <TextField {...params} className={`${styles.formElementTextFieled} ${styles.mail}`}
                                            key={`TextField_mail`}
                                            variant="outlined"
                                            type="email"
                                            {...register("mail", {
                                                required: {
                                                    value: true,
                                                    message: 'requiredError'
                                                },
                                                pattern: {
                                                    value: /\S+@\S+\.\S+/,
                                                    message: 'patternError'
                                                }
                                            })} />}
                                    />
                                    {/* <TextField
                                        className={`${styles.formElementTextFieled} ${styles.mail}`}
                                        key={`TextField_mail`}
                                        variant="outlined"
                                        type="email"
                                        {...register("mail", {
                                            required: {
                                                value: true,
                                                message: 'requiredError'
                                            },
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: 'patternError'
                                            }
                                        })}
                                    /> */}
                                    {errors.mail && <div className={styles.formError}>{errors.mail.message === "requiredError" ? t.fields.mail.requiredErrorMessage : t.fields.mail.formatErrorMessage}</div>}
                                </div>
                                <div className={styles.formControl}
                                    key={`FormControl_password`}>
                                    <InputLabel
                                        className={`${styles.formElementLabel} ${styles.password} ${styles.requiredLabel}`}
                                        key={`InputLabel_password`}>{t.fields.password.label}</InputLabel>
                                    <TextField
                                        className={`${styles.formElementTextFieled} ${styles.password}`}
                                        key={`TextField_password`}
                                        variant="outlined"
                                        type={showPassword ? 'text' : 'password'}
                                        InputProps={{
                                            endAdornment:
                                                < InputAdornment position="end" >
                                                    <IconButton
                                                        className='passwordIcon'
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                    >
                                                        {showPassword ? <VisibilityOff className='visibilityIcon' /> : <Visibility className='visibilityIcon' />}
                                                    </IconButton>
                                                </InputAdornment>

                                        }}

                                        {...register("password", {
                                            required: {
                                                value: true,
                                                message: 'requiredError'
                                            }
                                        })}
                                    />
                                    {errors.password && <div className={styles.formError}>{errors.password.message === "requiredError" ? t.fields.password.requiredErrorMessage : t.fields.password.formatErrorMessage}</div>}
                                </div>

                                <div className={styles.rememberMeSection}>
                                    <div className={styles.rememberMeCheckbox}>
                                        <Checkbox className={`${styles.formElementTextFieled} ${styles.rememberMe}`}
                                            key={`TextField_rememberMe`}
                                            {...register("rememberMe", {})} />

                                        <label>{t.fields.rememberMe.label}</label>
                                    </div>

                                    <div className={styles.forgotPasswordLink}>
                                        <Link href={`${FORGOT_PASSWORD_PATH}`}>{t['forgotPasswordLabelText']}</Link>
                                    </div>
                                </div>
                                {errors.rememberMe && <div className={styles.formError}>{errors.rememberMe.message === "requiredError" ? t.fields.rememberMe.requiredErrorMessage : t.fields.rememberMe.formatErrorMessage}</div>}
                                {/* <div className={styles.termsConditionsSection}>
                                    <div className={styles.termsConditionsCheckbox}>
                                        <Checkbox className={`${styles.formElementTextFieled} ${styles.terms}`}
                                            key={`TextField_terms`}
                                            {...register("terms", {
                                                required: {
                                                    value: true,
                                                    message: 'requiredError'
                                                }
                                            })} />
                                        <label><CommonPopup popupTitle="termsConditionsRegistrationTitle" popupSubtitle="termsConditionsRegistrationSubtitle" popupBody="termsConditionsRegistrationBody" defaultOpenState ={false} buttonText={t.fields.terms.label}/></label>
                                    </div>
                                </div>
                                {errors.terms && <div className={styles.formError}>{errors.terms.message === "requiredError" ? t.fields.terms.requiredErrorMessage : t.fields.terms.formatErrorMessage}</div>} */}
                                <div className={styles.submitButtonSection}>
                                    <button className={`${styles.submit_button} main_button ${(checkSubmitIsEnabled() && (!nextStepLoading)) ? 'enabled' : 'disabled'}`} disabled={nextStepLoading} type="submit">{t.submitButtonText}{nextStepLoading && <CircularProgress className={styles.loader} />}</button>

                                </div>

                                {!isUAEPassLogin && loginSuccessStatus !== "Authentication Successful" && <div className={styles.loginFailure}>
                                    {t[loginSuccessStatus]}
                                </div>}

                                {
                                    (["useFasttrackLink", "noPropertiesMessage"].indexOf(user.userMessage) !== -1) && <div className={styles.loginFailure}>
                                        {t[user.userMessage]}
                                    </div>
                                }

                            </form>




                        </section>

                        <div className={styles.orSeperator}>{t.orSperatorText}</div>

                        <button className={`${styles.button} ${styles.UAE_button} ${(isUAEPassLogin && isUAEPassLoading) ? 'disabled' : 'enabled'}`} disabled={isUAEPassLogin && isUAEPassLoading} onClick={loginUAEPass}><img src="/live/en/iceridgeresources/images/uaePassLogo.svg"></img>{t['uaeBtnText']}</button>

                            {(isUAEPassLogin && isUAEPassLoading) && <div className={styles.loginSuccess}>
                                <CircularProgress className={`${styles.loader} orangeSpinner`} />
                            </div>}
                            {(isUAEPassLogin && loginSuccessStatus !== "Authentication Successful") && <div className={styles.loginFailure}>
                                {t[loginSuccessStatus] ?? loginSuccessStatus}
                            </div>}
                            {!isUAEPassLoading && (["UAEPassInvalidCustomerText", "notSOP3Text"].indexOf(user.userMessage) !== -1) && <div className={styles.loginFailure}>
                                {t[user.userMessage]}
                            </div>}

                    </div>
                </div>
            </div >
        </>

    )
}
Login.getLayout = (page: any) => {
    return (
        <LoggedOutLayout showDownloadPopUp={true}>{page}</LoggedOutLayout>
    )
}

export default Login;
